require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./distressed-property-strategy.json") })
        }
      }, "path---distressed-property-strategy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---distressed-property-strategy!./.cache/json/distressed-property-strategy.json
// module id = 875
// module chunks = 231608221292675